// removed by extract-text-webpack-plugin
module.exports = {"buttons":"buttons__22Dwj","name":"name__29HxH"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Application/coms/ApplicationDetail/coms/ParseView/coms/ParserDelModal/styles.scss
// module id = 2221
// module chunks = 1